import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import { map, isEmpty, size } from "lodash";
//import Lead from "./Lead";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import Moment from 'react-moment';
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import editIcon from "../../assets/images/icons/edit2.png";
import deleteIcon from "../../assets/images/icons/bin.png";
import feedbackImg from "../../assets/img/feebback-icon.png"
import opnehouseImg from "../../assets/img/openhouse-icon.png"
import { addClientSellerShwoing, getClientSellerListing, getClientSellerShwoing, deleteClientShowing, updateClientSellerShowing } from "../../store/showing/actions"
import DeleteModal from "../../components/Common/DeleteModal";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  CardHeader,
  Table,
  Alert,
} from "reactstrap"
import moment from "moment";
import axios from "axios";
import { API_URL } from "helpers/api_url";
import { select } from "redux-saga/effects";
import TimePicker from "components/Common/Timepicker";
import PhoneInputField from "components/dropdowns/PhoneInputField";
import compareIcon from "../../assets/img/compare-icon.png"
class SellerShowing extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showing: '',
      openhouseFeedbacks: [],
      selectedListingId: '',
      selectedShowingId: '',
      listing: '',
      filteredShowings: this.props.showings || [], // if you're using props
    }
    this.handleSellerShowingSubmit = this.handleSellerShowingSubmit.bind(this)
    this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
    this.toggleBackdrop = this.toggleBackdrop.bind(this);
    this.onClickDelete = this.onClickDelete.bind(this);
    this.toggleOpenhouse = this.toggleOpenhouse.bind(this);
    this.toggleFeedback = this.toggleFeedback.bind(this);
     this.openOffer = this.openOffer.bind(this);
  }
     toggleOffer() {
    this.setState(prevState => ({
      isOffer: !prevState.isOffer
    }));
  }
   openOffer() {
    this.setState({  isOffer: !this.state.isOffer });
    this.toggleOffer();
  }
  openOffer(){
    this.fetchOffer(this.state.selectedShowingId || 0)
    this.toggleOffer();
  }
   fetchOffer(listingId) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const params = {
        listingId: listingId,
        agentId: parseInt(localStorage.getItem('userId')),
      }
      axios
        .get(`${API_URL}ClientOffer/GetSellerClientOffersByListingIdForCompare`, { headers, params })
        .then((response) => {
          this.setState({ offersData: response.data, loading: false });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
        });
    }
  getNotification = (type) => {
    if (type == 1)
      return '1 hr';
    else if (type == 30)
      return '30 Min';
    else
      return 'No need for notification';

  }
  handleListingFilterChange = (e) => {
    const selectedShowingId = e.target.value;
    this.setState({ selectedShowingId }, this.filterShowings);
  };
  filterShowings = () => {
    const { selectedShowingId } = this.state;
    const { showings } = this.props;

    let filtered = showings;
    if (selectedShowingId) {
      filtered = showings.filter(
        showing => String(showing.clientListing?.id) === selectedShowingId
      );
    }

    this.setState({ filteredShowings: filtered });
  };
  handleListingChange = (e) => {
    this.setState({ selectedListingId: e.target.value });
  };
  toggleOpenhouse() {
    this.setState({ isOpenhouse: !this.state.isOpenhouse });
  }
  toggleFeedback() {
    this.setState({ isFeedback: !this.state.isFeedback });
  }
  toggleBackdrop() {
    this.setState({ isBackdrop: !this.state.isBackdrop });
  }
  toggleDeleteModal = () => {
    this.setState(prevState => ({
      deleteModal: !prevState.deleteModal,
    }));
  };
  onClickDelete = (showing) => {
    this.setState({ showing: showing });
    this.setState({ deleteModal: true });
  };
  toggle() {
    this.setState(prevState => ({
      isRight: !prevState.isRight
    }));
  }
  handleDeleteShowing = () => {
    const { onDeleteShowing } = this.props;
    const { showing } = this.state;

    if (showing.id !== undefined) {
      onDeleteShowing(showing);
      this.setState({ deleteModal: false });
    }
  };
  handleSellerShowingSubmit = (value, actions) => {
    const payload = {
      clientListingId: parseInt(value.clientListingId),
      showingDate: moment(value.showingDate).format("YYYY-MM-DD"),
      startTime: value.startTime,
      endTime: value.endTime,
      agentName: value.agentName,
      agentOrganization: value.agentOrganization,
      agentContact: value.agentContact,
      agentEmail: value.agentEmail,
      notificationMinutes: parseInt(value.notification) || 0,
      clientId: parseInt(value.clientId),
      agentId: parseInt(value.agentId)

    }
    this.props.addClientSellerShwoing(payload, (status)=>{
      if(status==true){
          actions.resetForm();
      }
    });
  }
  componentDidMount() {
    const { onGetClientSellerListing, onGetClientSellerShowing } = this.props;
    onGetClientSellerListing(localStorage.getItem('userId'));
    onGetClientSellerShowing(localStorage.getItem('userId'));
    this.fetchSellerOpenhouse();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { showings } = this.props;
    if (!isEmpty(showings) && size(prevProps.showings) !== size(showings)) {
      this.setState({ showings: {}, isEdit: false });
    }
    if (prevProps.showings !== this.props.showings) {
      this.filterShowings();
    }

  }
  toggleRightCanvas() {
    this.setState({ showing: "", isEdit: false, isRight: !this.state.isRight });
    this.toggle();
  }
  toggleRightCanvas = arg => {
    const showing = arg;

    this.setState({
      showing: {
        id: showing.id,
        clientSellerShowingId: showing.clientSellerShowingId,
        clientId: showing.clientId,
        agentId: showing.agentId,
        clientListingId: showing.clientListingId,
        showingDate: showing.showingDate,
        startTime: showing.startTime,
        endTime: showing.endTime,
        agentName: showing.agentName,
        agentOrganization: showing.agentOrganization,
        agentContact: showing.agentContact,
        agentEmail: showing.agentEmail,
        feedback: showing.feedback,
        notificationMinutes: showing.notificationMinutes,
        isActive: true
      },
      isEdit: true,
    });
    this.toggle();
  };
  fetchSellerOpenhouse() {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    const params = {
      clientId: localStorage.getItem("userId"),
      agentId: localStorage.getItem("agentId")
    };
    axios
      .get(`${API_URL}ClientSellerOpenhouse/all`, { headers, params })
      .then((response) => {
        this.setState({ openhouseFeedbacks: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }


  getStatus(id) {
    if (id === 4) return 'Offer Received';
    if (id === 5) return 'Offer Accepted';
    if (id === 6) return 'Offer Withdrawn';
    if (id === 20) return 'Offer Rejected';
  }
  render() {

    const { listings, showings, onUpdateClientSellerShowing } = this.props;
    const { isEdit, deleteModal, openhouseFeedbacks, selectedListingId, offersData } = this.state;
    const showing = this.state.showing;
    
    const filteredShowings = showings.filter(
      (showing) =>
        String(showing.clientListingId) === selectedListingId && showing.feedback
    );
    const offers = offersData?.map(item => ({
  agent: item.agentName || item.partyName || "N/A",
  offerDate: item.offerDate
    ? new Date(item.offerDate).toLocaleDateString("en-US", { day: 'numeric', month: 'short', year: 'numeric' })
    : "N/A",
  price: item.askingPrice ? `$${item.askingPrice.toLocaleString()}` : "N/A",
  deposit: item.deposit ? `$${item.deposit.toLocaleString()}` : "N/A",
  closingDate: item.closingDate
    ? new Date(item.closingDate).toLocaleDateString("en-US", { day: 'numeric', month: 'short', year: 'numeric' })
    : "N/A",
  expiry: item.expiryDate
  ? `${new Date(item.expiryDate).toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    })} ${item.expiryTime || ""}`
  : "N/A",
  conditions: item.clientDealConditionStates
    ?.filter(c => c.status === true)
    .map(c => c.clientDealConditionTitle || `Condition ${c.clientDealConditionId}`)
})) || []; 
  const allConditionTitles = Array.from(
    new Set(offers.flatMap(o => o.conditions || []))
  );
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
          <div className="loading">Loading&#8230;</div>
        ) : null}
        <ToastContainer autoClose={2000} />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteShowing}
          onCloseClick={() => this.setState({ deleteModal: false })}
        />
        <div className="page-content">
          <MetaTags>
            <title>Seller Showings  | Realty Space</title>
          </MetaTags>
          <Container fluid>
            {/* <Breadcrumbs
              title={this.props.t("Seller")}
              breadcrumbItem={this.props.t("Seller Showings ")}
            /> */}
            <Row>


              <Col xl="12">
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    clientListingId:  "",
                    showingDate: '',
                    notification:'',
                    agentId: localStorage.getItem('agentId'),
                    clientId: localStorage.getItem('userId'),
                    startTime: '',
                    endTime: '',
                    agentName:'',
                    agentOrganization:'',
                    agentContact:'',
                    agentEmail:''
                  }}
                  validationSchema={Yup.object().shape({
                    clientListingId: Yup.string().required("This is Required"),
                    showingDate: Yup.string().required("This is Required"),
                    startTime:Yup.string().required("This is Required"),
                    endTime:Yup.string().required("This is Required"),

                  })}

                  onSubmit={this.handleSellerShowingSubmit}
                >
                  {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                    <Form
                      className="needs-validation"
                    >
                      <Card className="rs-card-bg">
                        <CardBody>

                          <Row>
                            <Col sm="6">
                              <h5>Add a showing</h5>
                            </Col>

                          </Row>

                          <Row>
                            <Col sm="2">
                              <FormGroup className="mb-3">
                                <Label htmlFor="clientListingId">
                                  {this.props.t("Select Property")}
                                </Label>
                                <Field as="select" name="clientListingId" className={
                                  "form-control" +
                                  (errors.clientListingId && touched.clientListingId
                                    ? " is-invalid"
                                    : "")
                                } onChange={handleChange}>
                                  <option value="">Select</option>
                                  {map(listings, (listing, listingskey) => (
                                    <option key={"_list_" + listingskey} value={listing.id}>{listing.mlsId}</option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="clientListingId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>

                            <Col sm="2">
                              <FormGroup className="mb-3">
                                <Label htmlFor="showingDate">
                                  {this.props.t("Date")}
                                </Label>
                                <InputGroup>
                                  <Flatpickr
                                    className={
                                      "form-control" +
                                      (errors.showingDate && touched.showingDate
                                        ? " is-invalid"
                                        : "")
                                    }
                                    placeholder=""

                                    onChange={(value) => setFieldValue('showingDate', value[0])}
                                    options={{
                                      altInput: false,
                                      minDate: "today",
                                      altFormat: "F j, Y",
                                      dateFormat: "Y-m-d"
                                    }}
                                  />
                                </InputGroup>
                                <ErrorMessage
                                  name="showingDate"
                                  component="div"
                                  className="invalid-feedback"
                                />
                                 {errors.showingDate &&
                                              touched.showingDate ? (
                                                <div className="invalid-feedback d-block">
                                                  {errors.showingDate}
                                                </div>
                                              ) : null}
                              </FormGroup>
                            </Col>

                            <Col sm="2">
                            <TimePicker
                              name="startTime"
                              label="Start Time *"
                              value={values.startTime}
                              onChange={(val) => setFieldValue("startTime", val)}
                              onBlur={() => setFieldTouched("startTime", true)}
                              minTime={null}
                              error={errors.startTime}
                              touched={touched.startTime}
                            />
                                                       
                            
                            </Col>

                            <Col sm="2">
                               <TimePicker
                              name="endTime"
                              label="End Time *"
                              value={values.endTime}
                              onChange={(val) => setFieldValue("endTime", val)}
                              onBlur={() => setFieldTouched("endTime", true)}
                              minTime={values.startTime}
                              disabled={!values.startTime}
                              error={errors.endTime}
                              touched={touched.endTime}
                            />
                            </Col>
                            <Col sm="4">
                              <FormGroup className="mb-3">
                                <Label htmlFor="minBedRoom">
                                  {this.props.t("Send Text Notification")}
                                </Label>
                                <Field as="select" name="notification" className={
                                  "form-control" +
                                  (errors.notification && touched.notification
                                    ? " is-invalid"
                                    : "")
                                } onChange={handleChange}>
                                  <option value="">Please Select</option>
                                  <option value="1">1 HR</option>
                                  <option value="30">30 MIN</option>
                                  <option value="0">No need for notification</option>

                                </Field>
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row>
                            <Col sm="12"><h5>Agent Detail (Optional)</h5></Col>
                          </Row>
                          <Row>
                            <Col sm="3">
                              <FormGroup className="mb-3">
                                <Label htmlFor="agentName">
                                  {this.props.t("Agent Name")}
                                </Label>
                                <Field
                                  name="agentName"
                                  type="text"
                                  className={
                                    "form-control" +
                                    (errors.agentName && touched.agentName
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={handleChange}

                                />
                                <ErrorMessage
                                  name="agentName"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                            <Col sm="3">
                              <FormGroup className="mb-3">
                                <Label htmlFor="agentOrganization">
                                  {this.props.t("Agent Organization")}
                                </Label>
                                <Field
                                  name="agentOrganization"
                                  type="text"
                                  className={
                                    "form-control" +
                                    (errors.agentOrganization && touched.agentOrganization
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={handleChange}
                                />
                                <ErrorMessage
                                  name="agentOrganization"
                                  component="div"
                                  className="invalid-feedback" />
                              </FormGroup>
                            </Col>
                            <Col sm="3">
                            <PhoneInputField
                              label="Agent Contact"
                              name="agentContact"
                              country="ca"
                              value={values.agentContact}
                               setFieldValue={setFieldValue}
                              error={errors.agentContact}
                              touched={touched.agentContact}
                              required={false}
                            />
                            
                            </Col>
                            <Col sm="3">
                              <FormGroup className="mb-3">
                                <Label htmlFor="agentEmail">
                                  {this.props.t("Agent Email")}
                                </Label>
                                <Field
                                  name="agentEmail"
                                  type="text"
                                  className={
                                    "form-control" +
                                    (errors.agentEmail && touched.agentEmail
                                      ? " is-invalid"
                                      : "")
                                  }
                                  onChange={handleChange}
                                />
                                <ErrorMessage
                                  name="agentEmail"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Save</button></div>

                        </CardBody>
                      </Card>

                    </Form>
                  )}
                </Formik>

                <Row>
                  <Col sm="6"></Col>
                  <Col sm="6">
                    <div className="float-end">


                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Card className="rs-card-bg">
                     
                         <CardHeader>
                                                 <Row className="gy-3">
                          {/* Left Column - Buttons */}
                          <Col lg="4" md="12">
                                          <div className="text-uppercase d-flex align-items-center gap-2">
                          <Link
                            to="#"
                            onClick={this.toggleOpenhouse}
                            className="btn btn-outline-secondary bt-for"
                          >
                            <span className="d-flex align-items-center gap-2">
                               Open Houses
                              <img style={{ height: 16 }} src={opnehouseImg} alt="house" />
                            </span>
                          </Link>
                      
                          <Link
                            to="#"
                            onClick={this.toggleFeedback}
                            className="btn btn-outline-secondary bt-for"
                          >
                            <span className="d-flex align-items-center gap-2">
                              Showing Feedback
                              <img style={{ height: 16 }} src={feedbackImg} alt="view routes" />
                            </span>
                          </Link>
                         
                                    <Link 
                                    to="#" 
                                    onClick={this.openOffer} 
                                    className="btn btn-outline-secondary bt-for">
                                      
                                        <span className="d-flex align-items-center gap-2">
                                          Compare Offer
                                          <img style={{ height: 16 }} src={compareIcon} alt="compare offer" />
                                        </span>
                                      
                                    </Link>
                                 
                        
                        </div>
                          </Col>
                            <Col sm="1" style={{width:145}}>
                              <label style={{marginTop:10, fontSize:'13px', color:'#000', fontWeight:'normal', textTransform:'uppercase'}}>Select property</label>
                            </Col>
                            <Col lg="3" md="12">
                            <div className="d-flex flex-wrap gap-2">
                              {/* Listing Type */}
                              <div className="flex-grow-1" style={{ minWidth: "150px" }}>
                                <label className="visually-hidden" htmlFor="listingType">
                                  Listings
                                </label>
                                 <select name="clientListingId"
                                className="form-select select-filter-2"
                                value={this.state.selectedShowingId}
                                onChange={this.handleListingFilterChange}
                              > 
                                { listings.length > 1 &&
                                   <option value="">All Listings</option>
                                }
                                {map(listings, (listing, listingskey) => (
                                  <option key={"_list_" + listingskey} value={listing.id}>{listing.mlsId}</option>
                                ))}
                              </select>
                              </div>
                        
                            
                            </div>
                          </Col>
                        <Col lg="3" md="12">  </Col>
                          {/* Right Column - Filters */}
                        
                        </Row>
                        
                                              
                      </CardHeader>
                      <CardBody>
                       
                        <h5 className="card-title text-uppercase mb-4">Showings History</h5>

                        <div className="clearfix"></div>
                        <div className="table-responsive" style={{ marginTop: 40 }}>
                          <table className="table mb-0 table">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Property</th>
                                <th>Showing Date</th>
                               
                               
                                <th>Notification</th>
                                <th>Status</th>
                                <th>Edit | Delete</th>
                              </tr>
                            </thead>
                            <tbody>
                              {map(this.state.filteredShowings, (showing, showkey) => (
                                <tr key={"_list_" + showkey}>
                                  <th>{showkey + 1}</th>
                                  <td>{showing?.clientListing?.mlsId}</td>
                                  <td><Moment format="DD MMMM YYYY">{showing.showingDate}</Moment> / {showing.startTime} - {showing.endTime}</td>
                                  
                                  
                                  <td>{this.getNotification(showing.notificationMinutes)}</td>
                                 <td>
                                          
                                           {showing.statusId === 4 ? (
                                              <span className="btnOfferRecieved">{this.getStatus(showing.statusId)}</span>
                                            ) : showing.statusId === 5 ? (
                                              <span className="btnOfferAccepted">{this.getStatus(showing.statusId)}</span>
                                            ) : showing.statusId === 6 ? (
                                              <span className="btnOfferWithdrawn">{this.getStatus(showing.statusId)}</span>
                                            ) :  showing.statusId === 20 ? (
                                              <span className="btnOfferRejected">{this.getStatus(showing.statusId)}</span>
                                            ) : (
                                              <span className="">{this.getStatus(showing.statusId)}</span>
                                            )}
                                            


                                          </td>
                                  {/* <td>
                  <UncontrolledDropdown>
                                      <DropdownToggle className="btn btn-action" type="button" id="defaultDropdown">
                                        Action <i className="mdi mdi-chevron-down"></i>
                                      </DropdownToggle>
                                      <DropdownMenu>
                                        <DropdownItem onClick={() => this.toggleRightCanvas(showing)} href="#">Edit</DropdownItem>
                                        <DropdownItem onClick={() => this.onClickDelete(showing)}  href="#">Delete</DropdownItem>
                                       
                                        
                                      </DropdownMenu>
                                    </UncontrolledDropdown>
                  </td> */}
                                  <td> <img style={{ cursor: 'pointer' }} onClick={() => this.toggleRightCanvas(showing)} className='tab-img me-2' src={editIcon} /> <img style={{ cursor: 'pointer' }} onClick={() => this.onClickDelete(showing)} className='tab-img' src={deleteIcon} /></td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>


              </Col>

            </Row>
            <Offcanvas
              isOpen={this.state.isRight}
              direction="end"
              toggle={this.toggleRightCanvas}
            >
              <OffcanvasHeader toggle={this.toggleRightCanvas}>
                Update
              </OffcanvasHeader>
              <OffcanvasBody>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id: showing.id,
                    clientSellerShowingId: showing.clientSellerShowingId,
                    clientId: showing.clientId,
                    agentId: showing.agentId,
                    clientListingId: showing.clientListingId,
                    showingDate: showing.showingDate,
                    startTime: showing.startTime,
                    endTime: showing.endTime,
                    agentName: showing.agentName,
                    agentOrganization: showing.agentOrganization,
                    agentContact: showing.agentContact,
                    agentEmail: showing.agentEmail,
                    feedback: showing.feedback,
                    notificationMinutes: showing.notificationMinutes,
                    isActive: true


                  }}
                  validationSchema={Yup.object().shape({
                    clientListingId: Yup.string().required("This is Required"),
                    //agentName: Yup.string().required("This is Required"),
                    //agentOrganization: Yup.string().required("This is Required"),
                    //agentOrganization: Yup.string().required("This is Required"),

                  })}

                  onSubmit={values => {
                    //console.log(isEdit);
                    if (isEdit) {
                      const updateShowing = {
                        id: values.id,
                        clientSellerShowingId: values.clientSellerShowingId,
                        clientId: values.clientId,
                        agentId: values.agentId,
                        clientListingId: parseInt(values.clientListingId),
                        showingDate: moment(values.showingDate).format("YYYY-MM-DD"),
                        startTime: values.startTime,
                        endTime: values.endTime,
                        agentName: values.agentName,
                        agentOrganization: values.agentOrganization,
                        agentContact: values.agentContact,
                        agentEmail: values.agentEmail,
                        feedback: values.feedback,
                        notificationMinutes: parseInt(values.notificationMinutes),
                        isActive: true
                      };

                      onUpdateClientSellerShowing(updateShowing);
                    } else {

                    }

                    //this.setState({ selectedOrder: null });
                    this.toggle();
                  }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue, setFieldTouched }) => (
                    <Form
                      className="needs-validation"
                    >



                      <Row>
                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="clientListingId">
                              {this.props.t("Select Property")}
                            </Label>
                            <Field as="select" name="clientListingId" className={
                              "form-control" +
                              (errors.mlsURL && touched.mlsURL
                                ? " is-invalid"
                                : "")
                            } onChange={handleChange}>
                              <option value="">Select</option>
                              {map(listings, (listing, listingskey) => (
                                <option key={"_list_" + listingskey} value={listing.id}>{listing.mlsId}</option>
                              ))}
                            </Field>
                            <ErrorMessage
                              name="clientListingId"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>

                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="showingDate">
                              {this.props.t("Date")}
                            </Label>
                            <InputGroup>
                              <Flatpickr
                                className={
                                  "form-control" +
                                  (errors.showingDate && touched.showingDate
                                    ? " is-invalid"
                                    : "")
                                }
                                placeholder=""
                                value={values.showingDate}
                                onChange={(value) => setFieldValue('showingDate', value[0])}
                                options={{
                                  altInput: true,
                                  altFormat: "F j, Y",
                                  dateFormat: "Y-m-d"
                                }}
                              />
                            </InputGroup>
                          </FormGroup>
                        </Col>

                        <Col sm="6">
                          <TimePicker
                              name="startTime"
                              label="Start Time *"
                              value={values.startTime}
                              onChange={(val) => setFieldValue("startTime", val)}
                              onBlur={() => setFieldTouched("startTime", true)}
                              minTime={null}
                              error={errors.startTime}
                              touched={touched.startTime}
                            />
                     
                        </Col>

                        <Col sm="6">
                         <TimePicker
                              name="endTime"
                              label="End Time *"
                              value={values.endTime}
                              onChange={(val) => setFieldValue("endTime", val)}
                              onBlur={() => setFieldTouched("endTime", true)}
                              minTime={values.startTime}
                              disabled={!values.startTime}
                              error={errors.endTime}
                              touched={touched.endTime}
                            />
                       
                        </Col>
                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="minBedRoom">
                              {this.props.t("Send Text Notification")}
                            </Label>
                            <Field as="select" name="notificationMinutes" className={
                              "form-control" +
                              (errors.notificationMinutes && touched.notificationMinutes
                                ? " is-invalid"
                                : "")
                            } onChange={handleChange}>
                              <option value="">Please Select</option>
                              <option value="1">1 HR</option>
                              <option value="30">30 MIN</option>
                              <option value="2">No need for notification</option>

                            </Field>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm="12"><h5>Agent Detail (Optional)</h5></Col>
                      </Row>
                      <Row>
                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="agentName">
                              {this.props.t("Agent Name")}
                            </Label>
                            <Field
                              name="agentName"
                              type="text"
                              className={
                                "form-control" +
                                (errors.agentName && touched.agentName
                                  ? " is-invalid"
                                  : "")
                              }
                              onChange={handleChange}

                            />
                            <ErrorMessage
                              name="agentName"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="agentOrganization">
                              {this.props.t("Agent Organization")}
                            </Label>
                            <Field
                              name="agentOrganization"
                              type="text"
                              className={
                                "form-control" +
                                (errors.agentOrganization && touched.agentOrganization
                                  ? " is-invalid"
                                  : "")
                              }
                              onChange={handleChange}
                            />
                            <ErrorMessage
                              name="agentOrganization"
                              component="div"
                              className="invalid-feedback" />
                          </FormGroup>
                        </Col>
                        <Col sm="12">
                         <PhoneInputField
                                      label="Agent Phone"
                                      name="agentContact"
                                      value={values.agentContact}
                                      setFieldValue={setFieldValue}
                                      error={errors.agentContact}
                                      touched={touched.agentContact}
                                      country="ca"
                                      required={false}
                                    />
                        
                        </Col>
                        <Col sm="12">
                          <FormGroup className="mb-3">
                            <Label htmlFor="agentEmail">
                              {this.props.t("Agent Email")}
                            </Label>
                            <Field
                              name="agentEmail"
                              type="text"
                              className={
                                "form-control" +
                                (errors.agentEmail && touched.agentEmail
                                  ? " is-invalid"
                                  : "")
                              }
                              onChange={handleChange}
                            />
                            <ErrorMessage
                              name="agentEmail"
                              component="div"
                              className="invalid-feedback"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <div className="clearfix"><button type="submit" className="btn btn-primary w-md">Update</button></div>



                    </Form>
                  )}
                </Formik>

              </OffcanvasBody>
            </Offcanvas>



            <Offcanvas
              isOpen={this.state.isOpenhouse}
              direction="end"
              toggle={this.toggleOpenhouse}
              style={{width:800}}
            >
              <OffcanvasHeader toggle={this.toggleOpenhouse}>
                Open House Feedback
              </OffcanvasHeader>
              <OffcanvasBody>
                {openhouseFeedbacks?.map((feedback, key) => (
                  <div key={key}>
                    <h6 style={{ fontSize: 15, color: 'red' }}>Open House date:  {feedback?.openhouseDate ? <Moment format="MMM, d YYYY">{feedback?.openhouseDate}</Moment> : ''} </h6>

                    <p style={{ fontSize: 15 }}>Number of visitors : {feedback?.noOfVisitors}</p>


                    {feedback.feedbackToClient && (
                      <div>
                        <h5>General Impression</h5>
                        <p style={{ fontSize: 13 }}>{feedback.feedbackToClient}</p>
                        <hr />
                      </div>
                    )}
                    {feedback.reactionPropertyFeatures && (
                      <div>
                        <h5>Reactions on any property feature</h5>
                        <p style={{ fontSize: 13 }}>{feedback.reactionPropertyFeatures}</p>
                        <hr />
                      </div>
                    )}

                    {feedback.reactionWhatnotLiked && (
                      <div>
                        <h5>Reactions on  what not not liked</h5>
                        <p style={{ fontSize: 13 }}>{feedback.reactionWhatnotLiked}</p>
                        <hr />
                      </div>
                    )}

                    {feedback.commentsOnPricing && (
                      <div>
                        <h5>Comments on pricing</h5>
                        <p style={{ fontSize: 13 }}>{feedback.commentsOnPricing}</p>
                        <hr />
                      </div>
                    )}

                    {feedback.suggestionActionalbleInsights && (
                      <div>
                        <h5>Suggestions & Actionable Insights</h5>
                        <p style={{ fontSize: 13 }}>{feedback.suggestionActionalbleInsights}</p>
                        <hr />
                      </div>
                    )}


                    {feedback.marketPositioning && (
                      <div>
                        <h5>Market Positioning</h5>
                        <p style={{ fontSize: 13 }}>{feedback.marketPositioning}</p>
                        <hr />
                      </div>
                    )}
                  </div>
                ))}


              </OffcanvasBody>
            </Offcanvas>



            <Offcanvas
              isOpen={this.state.isFeedback}
              direction="end"
              toggle={this.toggleFeedback}
              style={{width:800}}
            >
              <OffcanvasHeader toggle={this.toggleFeedback}>
                Showings Feeback
              </OffcanvasHeader>
              <OffcanvasBody>
                <label htmlFor="clientListingId">Select Listing</label>
                <select name="clientListingId" className="form-control"
                  value={selectedListingId}
                  onChange={this.handleListingChange}
                >
                  <option value="">Select</option>
                  {map(listings, (listing, listingskey) => (
                    <option key={"_list_" + listingskey} value={listing.id}>{listing.mlsId}</option>
                  ))}
                </select>
                <div style={{ margin: '10px 0px' }}></div>
                {filteredShowings.length > 0 ? (
                  map(filteredShowings, (showing, showkey) => (
                    <div
                      key={showkey}
                      style={{ margin: '10px 0px', float: 'left', width: '100%' }}
                    >
                      <h6 style={{ fontSize: '0.8125rem' }}>
                        Showing: {moment(showing.showingDate).format('Do MMMM YYYY')}
                        {showing?.startTime && (
                          <> @ {showing.startTime}</>
                        )}
                      </h6>
                      <p style={{ fontSize: '0.8125rem' }}>{showing.feedback}</p>
                      <hr />
                    </div>
                  ))
                ) : selectedListingId ? (
                  <p>No feedback found for this listing.</p>
                ) : null}
              </OffcanvasBody>
            </Offcanvas>
          </Container>
        </div>
            <Offcanvas
              isOpen={this.state.isOffer}
              direction="end"
              toggle={this.openOffer}
              style={{width:800}}
            >
              <OffcanvasHeader toggle={this.openOffer}>
                Compare Offer
              </OffcanvasHeader>
              <OffcanvasBody>
                {this.state.selectedShowingId > 0 ? (
                  <>
                   <Table bordered responsive>
        <thead>
          <tr>
            <th>Overview</th>
            {offers.map((o, i) => (
              <th key={i} className="">{o.agent}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Offer date</td>
            {offers.map((o, i) => <td key={i}>{o.offerDate}</td>)}
          </tr>
          <tr>
            <td>Offer Price</td>
            {offers.map((o, i) => <td key={i}>{o.price}</td>)}
          </tr>
          <tr>
            <td>Deposit amount</td>
            {offers.map((o, i) => <td key={i}>{o.deposit}</td>)}
          </tr>
          <tr>
            <td>Closing Date</td>
            {offers.map((o, i) => <td key={i}>{o.closingDate}</td>)}
          </tr>
          <tr>
            <td>Offer expiry date/time</td>
            {offers.map((o, i) => <td key={i}>{o.expiry}</td>)}
          </tr>

          {/* Divider row for Conditions */}
          <tr className="table-secondary">
            <td colSpan={offers.length + 1}><strong>Conditions</strong></td>
          </tr>
          {allConditionTitles.map((title, idx) => (
          <tr key={idx}>
            <td>{title}</td>
            {offers.map((o, i) => (
              <td key={i}>{o.conditions.includes(title) ? "✔️" : ""}</td>
            ))}
          </tr>
        ))}
        </tbody>
                    </Table>
                  </>
                ):(
                  <>
                    <Alert color="danger">Select a property to view offers from <strong>Select Property</strong> dropdown</Alert>
                  </>
                )}
                    
              </OffcanvasBody>
              </Offcanvas>
      </React.Fragment>
    )
  }
}
SellerShowing.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  addClientSellerShwoing: PropTypes.func,
  onGetClientSellerListing: PropTypes.func,
  listings: PropTypes.array,
  onGetClientSellerShowing: PropTypes.func,
  showings: PropTypes.array,
  onDeleteShowing: PropTypes.func,
  onUpdateClientSellerShowing: PropTypes.func,
  loading: PropTypes.object

}
const mapStateToProps = ({ Showings }) => (
  {
    listings: Showings.listings,
    showings: Showings.showings,
    loading: Showings.loading

  })
const mapDispatchToProps = dispatch => ({
  addClientSellerShwoing: (data, callback) => dispatch(addClientSellerShwoing(data, callback)),
  onGetClientSellerListing: (clientId) => dispatch(getClientSellerListing(clientId)),
  onGetClientSellerShowing: (clientId) => dispatch(getClientSellerShwoing(clientId)),
  onDeleteShowing: (id) => dispatch(deleteClientShowing(id)),
  onUpdateClientSellerShowing: (data) => dispatch(updateClientSellerShowing(data))

});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SellerShowing))
